export default "https://play.google.com/store/apps/details?id=br.com.pdvend.retail";



// WEBPACK FOOTER //
// ./src/assets/enum/url/pdvend/index.js